import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0ca90bd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { stye: "width: 100%;" }
const _hoisted_2 = { class: "screener-card-size screener-card-border" }
const _hoisted_3 = { class: "screener-card-top" }
const _hoisted_4 = {
  key: 0,
  class: "pvd-title-root duration-apy-heading white-background bottom-border-separator"
}
const _hoisted_5 = {
  class: "pvd-title__heading pvd-title__heading--level-3 duration-width",
  "data-cy": "card-title-duration"
}
const _hoisted_6 = {
  class: "pvd-title__heading pvd-title__heading--level-3 regular-font",
  "data-cy": "card-title-apy"
}
const _hoisted_7 = {
  key: 1,
  class: "light-gray-background bottom-border-background"
}
const _hoisted_8 = { class: "screener-card-middle" }
const _hoisted_9 = {
  key: 0,
  class: "centered-table white-background"
}
const _hoisted_10 = { class: "centered-table-cell" }
const _hoisted_11 = {
  class: "card-title",
  "data-cy": "card-title"
}
const _hoisted_12 = {
  class: "card-return-title",
  "data-cy": "card-return-title"
}
const _hoisted_13 = {
  class: "green-amount",
  "data-cy": "card-return-amount"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "centered-table-cell" }
const _hoisted_17 = { class: "screener-card-bottom" }
const _hoisted_18 = {
  key: 0,
  class: "centered-table white-background"
}
const _hoisted_19 = { class: "centered-table-cell" }
const _hoisted_20 = { class: "half-height" }
const _hoisted_21 = { class: "half-height" }
const _hoisted_22 = ["id"]
const _hoisted_23 = {
  key: 1,
  class: "centered-table light-gray-background"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd_button = _resolveComponent("pvd-button")!
  const _component_pvd_link = _resolveComponent("pvd-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isBuyCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.duration) + " CD ", 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.fillInApy(_ctx.clientConstants.APY_TITLE)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isUnavailableCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isBuyCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.title), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.fillInDuration(_ctx.clientConstants.CALCULATED_RETURN)), 1),
                _createElementVNode("p", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_ctx.returnAmount), 1),
                  (!_ctx.showFractionalIcon)
                    ? (_openBlock(), _createElementBlock("sup", _hoisted_14, "*"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isUnavailableCard)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "centered-table light-gray-background educational-text",
              id: _ctx.isUnavailableCardTextId
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", null, _toDisplayString(_ctx.title), 1)
              ])
            ], 8, _hoisted_15))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.isBuyCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_pvd_button, {
                    "data-cy": _ctx.buttonCyId,
                    id: _ctx.buyButtonId,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackChoice())),
                    "pvd-href": _ctx.searchURL,
                    "pvd-native-anchor-attributes": "{\"target\": \"_blank\"}",
                    "pvd-icon-right": "action__open-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.clientConstants.REVIEW_AND_BUY), 1)
                    ]),
                    _: 1
                  }, 8, ["data-cy", "id", "pvd-href"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.showFractionalIcon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        id: _ctx.iconId,
                        class: "fractional-image",
                        src: "/prgw/digital/finewissues/client/assets/fractional-cd.svg",
                        alt: "Circle with fractional slice pulled out"
                      }, null, 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isUnavailableCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_pvd_link, {
                "pvd-id": _ctx.isUnavailableCardLinkId,
                "data-cy": "empty-card-link",
                "pvd-href": _ctx.searchURL,
                "pvd-new-window": "",
                "pvd-disable-underline": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.clientConstants.ALL_CD_OFFERINGS), 1)
                ]),
                _: 1
              }, 8, ["pvd-id", "pvd-href"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}